export default "__VITE_ASSET__RIPLm04v__"